__turbopack_context__.v({
  "plenty-button": "RcPLMG_plenty-button",
  "plenty-container": "RcPLMG_plenty-container",
});
